import { render, staticRenderFns } from "./SpecialistDetail.vue?vue&type=template&id=8497ac16&scoped=true"
import script from "./SpecialistDetail.vue?vue&type=script&lang=js"
export * from "./SpecialistDetail.vue?vue&type=script&lang=js"
import style0 from "./SpecialistDetail.vue?vue&type=style&index=0&id=8497ac16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8497ac16",
  null
  
)

export default component.exports